import { inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { CanDeactivateFn, Route } from '@angular/router'
import { ConfirmDialogComponent } from '@ziptility/components/dialogs'
import { Observable, of } from 'rxjs'

import {
  FeatureCommentsComponent,
  FeatureDetailsComponent,
  FeatureHistoryComponent,
  FeatureRoutinesComponent,
  FeatureTasksComponent,
  FeatureProductsComponent,
  AssetProfileComponent,
} from '.'
import { canViewTasksGuard } from '@ziptility/guards'

const canDeactivateAssetForm: CanDeactivateFn<FeatureDetailsComponent> = (
  component: FeatureDetailsComponent,
): Observable<boolean> => {
  if (component && component.vm.form?.dirty) {
    const matDialog = inject(MatDialog)
    const ref = matDialog.open(ConfirmDialogComponent, {
      data: {
        header: 'You have unsaved changes!',
        message: 'To go back, click Cancel. Otherwise click Leave without saving.',
        confirmText: 'Leave without saving',
      },
    })
    return ref.afterClosed()
  }
  return of(true)
}

export default [
  {
    path: 'features',
    children: [
      {
        path: ':featureId',
        component: AssetProfileComponent,
        children: [
          {
            path: '',
            component: FeatureDetailsComponent,
            canDeactivate: [canDeactivateAssetForm],
          },
          {
            path: 'tasks',
            component: FeatureTasksComponent,
          },
          {
            path: 'products',
            component: FeatureProductsComponent,
          },
          {
            path: 'routines',
            component: FeatureRoutinesComponent,
          },
          {
            path: 'comments',
            component: FeatureCommentsComponent,
          },
          {
            path: 'history',
            component: FeatureHistoryComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'features/:featureId/tasks/:taskId',
    loadComponent: () => import('../task/task-container.component').then((m) => m.TaskContainer),
  },
  {
    path: 'create-task',
    loadComponent: () => import('../task/task-container.component').then((m) => m.TaskContainer),
    canActivate: [canViewTasksGuard],
  },
] satisfies Route[]
